import { useNavigate } from 'react-router-dom'
import addImage from '../assets/addImage.png'
import Deadline from '../assets/deadline-note-img.svg'
import xBirt from '../assets/generating.svg'
import PackOfIcons from '../assets/packoficons.svg'
import TwentyFourSeven from '../assets/twentyfourseven.svg'
import UiPeace from '../assets/ui-peace-img.svg'

export default function FeaturesSection() {
  const navigate = useNavigate()
  return (
    <section className='py-8 sm:py-12 lg:py-16 bg-white'>
      <div className='mx-auto px-4 sm:px-6 lg:px-20 flex flex-col items-center justify-center w-full'>
        <div className='text-center mb-8 sm:mb-10 lg:mb-12'>
          <h2 className='text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 text-balance'>
            Features Of BritFiler
          </h2>
          <p className='text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 max-w-xs sm:max-w-2xl lg:max-w-3xl mx-auto text-pretty px-4 sm:px-0'>
          BritFiler combines modern design, automation, and compliance checks to make your tax and company filings simple, accurate, and stress-free. Whether you're a small business owner, freelancer, or accountant managing multiple clients — our tools are built to save you time and eliminate errors.
          </p>
          <button 
            onClick={() => navigate('/sign-up')}
            className='bg-[#0A2540] hover:bg-[#0A2540]/90 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg shadow-lg text-sm sm:text-base transition-colors cursor-pointer'
          >
            Get Started
          </button>
        </div>

        {/* Desktop Layout (lg and above) - Uses flex-wrap for graceful degradation */}
        <div className='hidden lg:flex flex-row flex-wrap items-start justify-center w-full gap-4'>
          <div className='flex flex-col items-center justify-center gap-4 flex-1 min-w-[450px]'>
            <div className='bg-[#EEF0F2] w-full min-h-[280px] rounded-[32px] flex flex-row flex-wrap items-center xl:items-start justify-center p-6 xl:pl-10 xl:pt-20 gap-4'>
              <div className='flex flex-col items-start justify-center flex-1 min-w-[280px]'>
                <div className='text-black text-start text-[20px] xl:text-[30px] font-[700]'>
                  HMRC & Companies House Integration
                </div>
                <div className='text-[#868589] text-[14px] xl:text-[16px] text-start mt-2'>
                  BritFiler is fully integrated with both HMRC and Companies House through secure APIs.
                </div>
                <ul className='text-[#868589] text-[14px] xl:text-[16px] text-start mt-2 list-disc list-inside space-y-1'>
                  <li>Submit directly — no middlemen.</li>
                  <li>Receive instant acknowledgment.</li>
                  <li>Always stay compliant with up-to-date regulations.</li>
                  <li>Benefit: No waiting, no errors — just fast, compliant filing.</li>
                </ul>
              </div>
              <img
                src={UiPeace}
                alt='ui peace'
                className='mt-4 xl:mt-36 hidden xl:flex flex-shrink-0'
              />
            </div>
            <div className='flex flex-row flex-wrap items-stretch justify-center gap-4 w-full'>
              <div className='flex flex-col items-center justify-center gap-4 flex-1 min-w-[250px]'>
                <div className='bg-[#EEF0F2] w-full min-h-[120px] rounded-[32px] flex flex-col items-center justify-center p-6'>
                  <div className='flex flex-col items-start justify-center w-full'>
                    <div className='text-black text-start text-[20px] xl:text-[30px] font-[700]'>
                      Guided Filing Wizards
                    </div>
                    <div className='text-[#868589] text-[14px] xl:text-[16px] font-[400] text-start mt-2'>
                      Step-by-step, user-friendly workflows designed for
                      non-accountants to reduce errors and save time.
                    </div>
                  </div>
                </div>
                <div className='bg-[#EEF0F2] w-full min-h-[250px] rounded-[32px] flex flex-col items-center justify-center p-6'>
                  <img
                    src={xBirt}
                    alt='xbirt'
                    className='w-full max-w-[300px] hidden xl:flex'
                  />
                  <div className='flex flex-col items-start justify-center mt-4 xl:mt-6 w-full'>
                    <div className='text-black text-start text-[20px] xl:text-[30px] font-[700]'>
                      iXBRL Tagging & Accounts Generation
                    </div>
                    <div className='text-[#868589] text-[14px] xl:text-[16px] font-[400] text-start mt-2'>
                      Automated tagging of financial data (Balance Sheet, P&L)
                      into iXBRL format compliant with FRS standards.
                    </div>
                  </div>
                </div>
              </div>
              <div className='bg-[#EEF0F2] flex-1 min-w-[180px] min-h-[300px] rounded-[32px] flex flex-col items-center justify-center p-6'>
                <div className='flex flex-col items-start justify-center w-full'>
                  <div className='text-black text-start text-[20px] xl:text-[30px] font-[700]'>
                    24/7 Customer Support
                  </div>
                  <div className='text-[#868589] text-[14px] xl:text-[16px] font-[400] text-start mt-2'>
                    Our customer support team is always available to assist you
                    with any questions about the platform.
                  </div>
                </div>
                <img
                  src={TwentyFourSeven}
                  alt='24/7 support'
                  className='mt-6 xl:mt-[34px] w-full max-w-[200px] hidden xl:flex'
                />
              </div>
            </div>
          </div>
          <div className='flex flex-col items-center justify-center gap-4 flex-1 min-w-[350px]'>
            <div className='bg-[#EEF0F2] w-full min-h-[280px] rounded-[32px] flex flex-row flex-wrap items-center justify-center p-6 gap-4'>
              <div className='flex flex-col items-start justify-center flex-1 min-w-[250px]'>
                <div className='flex flex-col items-start justify-center'>
                  <div className='text-black text-start text-[20px] xl:text-[30px] font-[700]'>
                    Deadline Management
                  </div>
                  <ul className='text-[#868589] text-[14px] xl:text-[16px] font-[400] text-start mt-2 list-disc list-inside space-y-1'>
                    <li>Automatic reminders for upcoming deadlines.</li>
                    <li>Configurable notification frequency (weekly, monthly, or custom).</li>
                    <li>Dashboard view of all important dates.</li>
                    <li>Early alerts for expiring Companies House or HMRC filings.</li>
                  </ul>
                </div>
                <img src={PackOfIcons} alt='Pack of Icons' className='mt-6 xl:mt-10' />
              </div>
              <img src={Deadline} alt='Deadline' className='hidden xl:flex flex-shrink-0 max-w-[180px]' />
            </div>
            <div className='bg-[#EEF0F2] w-full min-h-[300px] rounded-[32px] flex flex-row flex-wrap items-center justify-center p-6 gap-4'>
              <div className='flex flex-col items-start justify-center flex-1 min-w-[250px]'>
                <div className='flex flex-col items-start justify-center'>
                  <div className='text-black text-start text-[20px] xl:text-[30px] font-[700]'>
                    Built for Everyone
                  </div>
                  <ul className='text-[#868589] text-[14px] xl:text-[16px] font-[400] text-start mt-2 list-disc list-inside space-y-1'>
                    <li>Individuals filing Self Assessment returns.</li>
                    <li>Small Businesses & Startups managing corporation tax and company accounts.</li>
                    <li>Accountants handling multiple clients' filings.</li>
                    <li>Dormant Companies maintaining compliance with minimal effort.</li>
                  </ul>
                </div>
                <img src={PackOfIcons} alt='Pack of Icons' className='mt-6 xl:mt-10' />
              </div>
              <img src={addImage} alt='addImage' className='hidden xl:flex flex-shrink-0 max-w-[180px]' />
            </div>
          </div>
        </div>

        {/* Tablet Layout (md to lg) - Uses flex-wrap for better small-screen handling */}
        <div className='hidden md:flex lg:hidden flex-col items-center justify-center w-full gap-4 max-w-4xl px-4'>
          <div className='flex flex-row flex-wrap items-stretch justify-center w-full gap-4'>
            <div className='bg-[#EEF0F2] flex-1 min-w-[280px] min-h-[240px] rounded-[24px] flex flex-col items-start justify-center p-6'>
              <div className='text-black text-start text-[20px] font-[700] mb-2'>
                HMRC & Companies House Integration
              </div>
              <div className='text-[#868589] text-[14px] text-start'>
                BritFiler is fully integrated with both HMRC and Companies House through secure APIs.
              </div>
              <ul className='text-[#868589] text-[14px] text-start mt-2 list-disc list-inside space-y-1'>
                <li>Submit directly — no middlemen.</li>
                <li>Receive instant acknowledgment.</li>
                <li>Always stay compliant with up-to-date regulations.</li>
                <li>Benefit: No waiting, no errors — just fast, compliant filing.</li>
              </ul>
            </div>
            <div className='bg-[#EEF0F2] flex-1 min-w-[280px] min-h-[240px] rounded-[24px] flex flex-col items-start justify-center p-6'>
              <div className='text-black text-start text-[20px] font-[700] mb-2'>
                Deadline Management
              </div>
              <ul className='text-[#868589] text-[14px] text-start list-disc list-inside space-y-1'>
                <li>Automatic reminders for upcoming deadlines.</li>
                <li>Configurable notification frequency (weekly, monthly, or custom).</li>
                <li>Dashboard view of all important dates.</li>
                <li>Early alerts for expiring Companies House or HMRC filings.</li>
              </ul>
            </div>
          </div>
          <div className='flex flex-row flex-wrap items-stretch justify-center w-full gap-4'>
            <div className='bg-[#EEF0F2] flex-1 min-w-[200px] min-h-[180px] rounded-[24px] flex flex-col items-start justify-center p-5'>
              <div className='text-black text-start text-[18px] font-[700] mb-2'>
                Guided Filing Wizards
              </div>
              <div className='text-[#868589] text-[14px] text-start'>
                Step-by-step, user-friendly workflows designed for
                non-accountants to reduce errors and save time.
              </div>
            </div>
            <div className='bg-[#EEF0F2] flex-1 min-w-[200px] min-h-[180px] rounded-[24px] flex flex-col items-start justify-center p-5'>
              <div className='text-black text-start text-[18px] font-[700] mb-2'>
                iXBRL Tagging & Accounts Generation
              </div>
              <div className='text-[#868589] text-[14px] text-start'>
                Automated tagging of financial data (Balance Sheet, P&L) into
                iXBRL format compliant with FRS standards.
              </div>
            </div>
            <div className='bg-[#EEF0F2] flex-1 min-w-[200px] min-h-[180px] rounded-[24px] flex flex-col items-start justify-center p-5'>
              <div className='text-black text-start text-[18px] font-[700] mb-2'>
                24/7 Customer Support
              </div>
              <div className='text-[#868589] text-[14px] text-start'>
                Our customer support team is always available to assist you with
                any questions about the platform.
              </div>
            </div>
          </div>
          <div className='flex flex-row flex-wrap items-stretch justify-center w-full gap-4'>
            <div className='bg-[#EEF0F2] flex-1 min-w-[280px] min-h-[240px] rounded-[24px] flex flex-col items-start justify-center p-6'>
              <div className='text-black text-start text-[20px] font-[700] mb-2'>
                Built for Everyone
              </div>
              <ul className='text-[#868589] text-[14px] text-start list-disc list-inside space-y-1'>
                <li>Individuals filing Self Assessment returns.</li>
                <li>Small Businesses & Startups managing corporation tax and company accounts.</li>
                <li>Accountants handling multiple clients' filings.</li>
                <li>Dormant Companies maintaining compliance with minimal effort.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Mobile Layout (sm and below) */}
        <div className='flex md:hidden flex-col items-center justify-center w-full gap-3 px-2'>
          <div className='bg-[#EEF0F2] w-full min-h-[180px] rounded-[20px] max-w-[400px] flex flex-col items-start justify-center p-4'>
            <div className='text-black text-start text-[18px] font-[700] mb-2'>
              HMRC & Companies House Integration
            </div>
            <div className='text-[#868589] text-[14px] text-start'>
              BritFiler is fully integrated with both HMRC and Companies House through secure APIs.
            </div>
            <ul className='text-[#868589] text-[14px] text-start mt-2 list-disc list-inside space-y-1'>
              <li>Submit directly — no middlemen.</li>
              <li>Receive instant acknowledgment.</li>
              <li>Always stay compliant with up-to-date regulations.</li>
              <li>Benefit: No waiting, no errors — just fast, compliant filing.</li>
            </ul>
          </div>
          <div className='flex flex-row items-center justify-center w-full gap-3'>
            <div className='bg-[#EEF0F2] flex-1 min-h-[140px] rounded-[20px] flex flex-col items-start justify-center p-3'>
              <div className='text-black text-start text-[16px] font-[700] mb-1'>
                Guided Filing Wizards
              </div>
              <div className='text-[#868589] text-[12px] text-start'>
                Step-by-step, user-friendly workflows designed for
                non-accountants.
              </div>
            </div>
            <div className='bg-[#EEF0F2] flex-1 min-h-[140px] rounded-[20px] flex flex-col items-start justify-center p-3'>
              <div className='text-black text-start text-[16px] font-[700] mb-1'>
                24/7 Customer Support
              </div>
              <div className='text-[#868589] text-[12px] text-start'>
                Our customer support team is always available to assist you.
              </div>
            </div>
          </div>
          <div className='bg-[#EEF0F2] w-full min-h-[200px] rounded-[20px] max-w-[400px] flex flex-col items-start justify-center p-4'>
            <div className='text-black text-start text-[18px] font-[700] mb-2'>
              iXBRL Tagging & Accounts Generation
            </div>
            <div className='text-[#868589] text-[14px] text-start'>
              Automated tagging of financial data (Balance Sheet, P&L) into
              iXBRL format compliant with FRS standards.
            </div>
          </div>
          <div className='flex flex-row items-center justify-center w-full gap-3'>
            <div className='bg-[#EEF0F2] flex-1 min-h-[160px] rounded-[20px] flex flex-col items-start justify-center p-3'>
              <div className='text-black text-start text-[16px] font-[700] mb-1'>
                Deadline Management
              </div>
              <ul className='text-[#868589] text-[12px] text-start list-disc list-inside space-y-0.5'>
                <li>Automatic reminders for upcoming deadlines.</li>
                <li>Configurable notification frequency (weekly, monthly, or custom).</li>
                <li>Dashboard view of all important dates.</li>
                <li>Early alerts for expiring Companies House or HMRC filings.</li>
              </ul>
            </div>
            <div className='bg-[#EEF0F2] flex-1 min-h-[160px] rounded-[20px] flex flex-col items-start justify-center p-3'>
              <div className='text-black text-start text-[16px] font-[700] mb-1'>
                Built for Everyone
              </div>
              <ul className='text-[#868589] text-[12px] text-start list-disc list-inside space-y-0.5'>
                <li>Individuals filing Self Assessment returns.</li>
                <li>Small Businesses & Startups managing corporation tax and company accounts.</li>
                <li>Accountants handling multiple clients' filings.</li>
                <li>Dormant Companies maintaining compliance with minimal effort.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
